<template>
    <el-dialog title="咨询内容维护" :visible="visible" :show="show" width="720px" :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="资讯标题" class="input" prop="title" >
                <el-input v-model="ruleForm.title" autocomplete="off" placeholder="资讯标题" />

            </el-form-item>
            <el-form-item label="咨询封面" class="input" prop="img">
                <el-upload
                        ref="upload"
                        :action="fileUploadUrl"
                        list-type="picture-card"
                        :limit="1"
                        :file-list="fileList"
                        :on-exceed="handleExceed"
                        :on-success="handleUploadSuccess"
                        
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <img v-if="ruleForm.img" :src="url+'upload/'+ruleForm.img" style="width:150px;height:150px"/>
            </el-form-item>
            <el-form-item label="是否显示" class="input" prop="isShow" >
                <el-select v-model="ruleForm.isShow" style="width: 100%">
                    <el-option :label="'是'" :value="'1'"></el-option>
                    <el-option :label="'否'" :value="'2'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="咨询内容" prop="context">
                <editor v-model="ruleForm.context" v-show="this.rowData.type!='info'"></editor>
                <div v-show="this.rowData.type=='info'" v-html="ruleForm.context"></div>
            </el-form-item>

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    import editor from '@/components/common/Editor'
    export default{
        name:'addOrUpdate',
        compent:{editor},
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                }
            },
            rowData(){
                //this.ruleForm = this.rowData;
                this.$http({
                    url: "consult/info/"+this.rowData.id,
                    method: "get",
                }).then(({data}) => {
                    if (data.data!=null){
                        this.ruleForm = data.data;
                    }
                });
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                fileUploadUrl:base.get().fileUploadUrl,
                visible:false,
                ruleForm:{
                    title:'',
                    context:'',
                    isShow:'',
                    img:'',
                },
                rules:{
                    title:[{ required: true, message: '请输入咨询标题', trigger: 'blur' }],
                    context:[{ required: true, message: '请输入咨询内容', trigger: 'blur' }],
                    isShow:[{ required: true, message: '请选择是否显示', trigger: 'blur' }],
                },
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['upload'].clearFiles();
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`consult/`+"save":this.url+`consult/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            // 上传文件成功后执行
            handleUploadSuccess(res, file, fileList) {
                this.ruleForm.img = file.response.file;
            },
            handleExceed(files, fileList) {
                this.$message.warning(`最多上传${this.limit}张图片`);
            },

        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>